import { render, staticRenderFns } from "./BrandRecord.vue?vue&type=template&id=261ebc4a&scoped=true&"
import script from "./BrandRecord.vue?vue&type=script&lang=js&"
export * from "./BrandRecord.vue?vue&type=script&lang=js&"
import style0 from "./BrandRecord.vue?vue&type=style&index=0&id=261ebc4a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ebc4a",
  null
  
)

export default component.exports